import { render, staticRenderFns } from "./DriverFees.vue?vue&type=template&id=70c33b82&scoped=true"
import script from "./DriverFees.vue?vue&type=script&lang=js"
export * from "./DriverFees.vue?vue&type=script&lang=js"
import style0 from "./DriverFees.vue?vue&type=style&index=0&id=70c33b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c33b82",
  null
  
)

export default component.exports